import { 
      GET_ACTIVE_PROGRAMS_DATA_SUCCESS, 
      FETCH_ACTIVE_PROGRAMS_DATA_REQUEST, 
      GET_ACTIVE_PROGRAMS_DATA_FAILURE,
      EMPTY_ACTIVE_PROGRAMS_EXPORT_DATA_UPDATE,
      VBC_FILTER_TIME_PERIOD_UPDATE,
      VBC_FILTER_LOB_UPDATE,
      VBC_FILTER_TAXIDS_UPDATE,
      VBC_TAXIDS_REQUEST,
      VBC_TAXIDS_LOADING,
      VBC_TAXIDS_SUCCESS,
      VBC_TAXIDS_FAILURE,
      VBC_GEOFILTER_REGION,
      VBC_GEOFILTER_STATE,
      VBC_GEOFILTER_MARKET,
      GET_PAYOUTS_DATA_SUCCESS,
      FETCH_PAYOUTS_DATA_REQUEST,
      GET_PAYOUTS_DATA_FAILURE,
      GET_INFLATORS_DATA_SUCCESS,
      FETCH_INFLATORS_DATA_REQUEST,
      GET_INFLATORS_DATA_FAILURE
} from '../actionTypes';

export const setActiveProgramsData = (payload: any) => ({
      type: GET_ACTIVE_PROGRAMS_DATA_SUCCESS,
      payload
});

export const fetchActiveProgramsDataRequest = (payload: any) => ({
      type: FETCH_ACTIVE_PROGRAMS_DATA_REQUEST,
      payload
});


export const fetchActiveProgramsDataError = (payload: any) => ({
      type: GET_ACTIVE_PROGRAMS_DATA_FAILURE,
      payload
});

export const emptyActiveProgramsExportDataUpdate = () => ({
      type: EMPTY_ACTIVE_PROGRAMS_EXPORT_DATA_UPDATE
});

// Filter action creators
export const updateVbcTimePeriod = (payload: string) => ({
      type: VBC_FILTER_TIME_PERIOD_UPDATE,
      payload
});

export const updateVbcLob = (payload: string[]) => ({
      type: VBC_FILTER_LOB_UPDATE,
      payload
});

export const updateVbcTaxIds = (payload: string[]) => ({
      type: VBC_FILTER_TAXIDS_UPDATE,
      payload
});

// Geo segmentation filter action creators
export const updateVbcGeoRegion = (payload: any) => ({
      type: VBC_GEOFILTER_REGION,
      payload
});

export const updateVbcGeoState = (payload: any) => ({
      type: VBC_GEOFILTER_STATE,
      payload
});

export const updateVbcGeoMarket = (payload: any) => ({
      type: VBC_GEOFILTER_MARKET,
      payload
});

// Tax IDs async flow
export const fetchVbcTaxIdsRequest = (payload: any) => ({
      type: VBC_TAXIDS_REQUEST,
      payload
});
export const fetchVbcTaxIdsLoading = (payload: boolean) => ({
      type: VBC_TAXIDS_LOADING,
      payload
});
export const fetchVbcTaxIdsSuccess = (payload: any[]) => ({
      type: VBC_TAXIDS_SUCCESS,
      payload
});
export const fetchVbcTaxIdsFailure = (payload: any) => ({
      type: VBC_TAXIDS_FAILURE,
      payload
});

// Payouts action creators
export const setPayoutsData = (payload: any) => ({
      type: GET_PAYOUTS_DATA_SUCCESS,
      payload
});

export const fetchPayoutsDataRequest = (payload: any) => ({
      type: FETCH_PAYOUTS_DATA_REQUEST,
      payload
});

export const fetchPayoutsDataError = (payload: any) => ({
      type: GET_PAYOUTS_DATA_FAILURE,
      payload
});

// Inflators action creators
export const setInflatorsData = (payload: any) => ({
      type: GET_INFLATORS_DATA_SUCCESS,
      payload
});

export const fetchInflatorsDataRequest = (payload: any) => ({
      type: FETCH_INFLATORS_DATA_REQUEST,
      payload
});

export const fetchInflatorsDataError = (payload: any) => ({
      type: GET_INFLATORS_DATA_FAILURE,
      payload
});